import { useLingui } from '@lingui/react/macro';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import history from 'modules/overlay-canvas/addons/history';

import { OrientationEnum } from 'modules/overlay-canvas/addons/placeholders/complex/indicators-row';
import UDText from 'ud-ui/components/text';
import { selectFabricManager } from 'modules/template-editor/store/editor/selectors';
import Selector from 'modules/template-editor/ui/components/elements/selector';

interface IProps {
  onChange: (orientation: OrientationEnum) => void;
  value: OrientationEnum;
}

function ChoosingOrientation(props: IProps) {
  const { t } = useLingui();
  const options = [
    { label: t`По горизонтали`, value: OrientationEnum.HORIZONTAL },
    { label: t`По вертикали`, value: OrientationEnum.VERTICAL },
  ];
  const { onChange, value } = props;
  const manager = useSelector(selectFabricManager);

  const onFocusField = useCallback(() => {
    manager?.render();
    history.saveState();
  }, [manager]);

  return (
    <>
      <UDText type={'caption-1'}>{t`Ориентация`}</UDText>
      <Selector
        onFocus={onFocusField}
        onChange={(event) => {
          onChange(event?.value);
        }}
        options={options}
        value={options.find((option) => option.value === value)}
      />
    </>
  );
}

export default ChoosingOrientation;
